import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'
import { DuplicationModal } from './DuplicationModal.component'

const withUnmountHoc = withUnmountTransition(DuplicationModal)
export { withUnmountHoc as DuplicationModal }
